import { baseService } from "./base";

export const tagsService = {
  load() {
    return baseService.get(`/api/tags`);
  },
};

export default tagsService;
